// Attribution & device capture (first-touch persisted in localStorage).
const KEY = "mir_attribution";

function parseUA() {
  const ua = navigator.userAgent;
  let device = "Desktop";
  if (/Mobi|Android|iPhone/i.test(ua)) device = "Mobile";
  else if (/iPad|Tablet/i.test(ua)) device = "Tablet";

  let os = "Sconosciuto";
  if (/Windows/i.test(ua)) os = "Windows";
  else if (/Android/i.test(ua)) os = "Android";
  else if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS";
  else if (/Mac OS X/i.test(ua)) os = "macOS";
  else if (/Linux/i.test(ua)) os = "Linux";

  let browser = "Sconosciuto";
  if (/Edg/i.test(ua)) browser = "Edge";
  else if (/OPR|Opera/i.test(ua)) browser = "Opera";
  else if (/Chrome/i.test(ua)) browser = "Chrome";
  else if (/Firefox/i.test(ua)) browser = "Firefox";
  else if (/Safari/i.test(ua)) browser = "Safari";

  return { device, os, browser };
}

function detectProvenienza(p) {
  const src = (p.get("utm_source") || "").toLowerCase();
  if (p.get("gclid") || src.includes("google")) return "Google Ads";
  if (p.get("fbclid") || src.includes("facebook") || src === "fb") return "Facebook";
  if (src.includes("instagram") || src === "ig") return "Instagram";
  if (document.referrer && !document.referrer.includes(window.location.host)) return "Organico";
  return "Diretto";
}

export function captureAttribution() {
  if (typeof window === "undefined") return {};
  const existing = localStorage.getItem(KEY);
  if (existing) {
    try {
      return JSON.parse(existing);
    } catch (e) {
      /* fallthrough */
    }
  }
  const p = new URLSearchParams(window.location.search);
  const ua = parseUA();
  const data = {
    utm_source: p.get("utm_source") || "",
    utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "",
    utm_term: p.get("utm_term") || "",
    utm_content: p.get("utm_content") || "",
    referrer: document.referrer || "Diretto",
    landing_page: window.location.pathname + window.location.search,
    provenienza: detectProvenienza(p),
    ...ua,
  };
  localStorage.setItem(KEY, JSON.stringify(data));
  return data;
}

export function getAttribution() {
  return captureAttribution();
}
